
export const ComplianceGridEmpty = () => (
	<div
		className="rounded-md border border-dashed border-gray-200 py-10 text-center text-sm text-gray-500"
		data-testid="compliance-grid-empty"
	>
		No submitted suppliers found. Suppliers must submit their response before
		compliance can be assessed.
	</div>
);
